import { IPlanLopTinChiSelectRequest } from "../../../model/request/lop-tin-chi/IPlanLopTinChiSelectRequest";
import { IPlanLopTinChi } from "../../../model/respone/lop-tin-chi/IPlanLopTinChi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePlanLopTinChiActionsObj = {
  LOAD_START: {} as IPlanLopTinChiSelectRequest,
  LOAD_SUCCESS: {} as IPlanLopTinChi[],
  LOAD_ERRR: "",
};
export const ePlanLopTinChiActionIds = generateActionTypeIds(
  ePlanLopTinChiActionsObj,
  "PLAN_LOP_TIN_CHI"
);
export type IPlanLopTinChiActionTypes = IGenericActionType<
  typeof ePlanLopTinChiActionsObj,
  "PLAN_LOP_TIN_CHI"
>;
